import React from 'react';
import FilterSection from './FilterSection';
import {gettext} from '../../translations';
import {
    EVENTBRITE_CATEGORY_MAPPING,
    EVENTBRITE_CATEGORY_TO_REFINEMENT,
    DATES_MAPPING,
    DATES_TO_REFINEMENT,
    PRICE_MAPPING,
} from '../constants';
import invert from 'lodash/invert';
import withStickyScrollNewLayout from './withStickyScrollNewLayout';

import './FilterPanel.scss';

class FilterPanel extends React.PureComponent {
    _handleChange = (key, value, shouldUpdateRoute) => {
        const {
            handleApplyFilter,
            handleRemoveFilter,
        } = this.props;

        if (value === 'all') {
            handleRemoveFilter({[key]: true});
        } else {
            handleApplyFilter({[key]: value}, {}, shouldUpdateRoute);
        }
    };

    render() {
        return (
            <div className="filter-panel">
                <div className="filter-title">Filters</div>
                <FilterSection
                    title={gettext('Date')}
                    filters={{'all': gettext('All days'), ...DATES_MAPPING}}
                    onOptionChange={(value, redirect) => this._handleChange('dates', value, redirect)}
                    urlParameterMapping={invert(DATES_TO_REFINEMENT)}
                    moreLabel={gettext('More dates')}
                    moreThreshold={4}
                />
                <FilterSection
                    title={gettext('Categories')}
                    filters={{'all': gettext('All categories'), ...EVENTBRITE_CATEGORY_MAPPING}}
                    onOptionChange={(value, redirect) => this._handleChange('tags', value, redirect)}
                    urlParameterMapping={invert(EVENTBRITE_CATEGORY_TO_REFINEMENT)}
                    moreLabel={gettext('More categories')}
                    moreThreshold={4}
                />
                <FilterSection
                    title={gettext('Price')}
                    filters={{'all': gettext('All prices'), ...PRICE_MAPPING}}
                    onOptionChange={(value, redirect) => this._handleChange('price', value, redirect)}
                />
            </div>
        );
    }
}

export default withStickyScrollNewLayout(FilterPanel);
